/* Package JSON Import will be here */
import moment from 'moment';
import { push } from "connected-react-router";
import { appRoutesConst } from "app/navigation";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject, errorToast } from "utilities/utils";
import Constants from "utilities/appConstants";
import { showMsgFromJson } from "reducers/common";
import { exchangeSubmitApi, getDeliveryDateApi } from "services/order/exchangeSubmit";
import { forEach } from "lodash";
import { IExchangeSubmitParams, ISalesReturnUpload } from "models/salesReturnModels";
import { IOrderUploadParams } from "models/orderModels";
import { clearHistoryFilter } from "reducers/orderHistory/historyFilter";
import { getOrderHistory } from "reducers/orderHistory";
/* Project Import will be here */

export const types = {
    EXCHANGE_SUBMIT_REQUEST: "exchangeSubmit/EXCHANGE_SUBMIT_REQUEST",
    EXCHANGE_SUBMIT_SUCCESS: "exchangeSubmit/EXCHANGE_SUBMIT_SUCCESS",
    EXCHANGE_SUBMIT_FAILURE: "exchangeSubmit/EXCHANGE_SUBMIT_FAILURE",
    UPDATE_SELECTED_ADDRESS_ID: "exchangeSubmit/UPDATE_SELECTED_ADDRESS_ID",
    DELIVERY_DATE_REQUEST_AND_RESPONSE: "exchangeSubmit/DELIVERY_DATE_REQUEST_AND_RESPONSE"
};

const initialState = {
    isLoading: false,
    standardDeliveryDateLoading: false,
    standardDeliveryDate: "",
    selectedAddressId: 0,
    error: null
};

export const exchangeSubmit = (state = initialState, action) => {
    switch (action.type) {
        case types.EXCHANGE_SUBMIT_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.EXCHANGE_SUBMIT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ...action.payload
            };
        case types.EXCHANGE_SUBMIT_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        case types.DELIVERY_DATE_REQUEST_AND_RESPONSE:
            return {
                ...state,
                standardDeliveryDateLoading: false,
                ...action.payload
            };
        case types.UPDATE_SELECTED_ADDRESS_ID:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};

/* Submit all the collected data in exchange module and save the exchange return and exchange order in one go */
export const submitExchangeReturnAndExchangeOrder = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.EXCHANGE_SUBMIT_REQUEST });
        try {
            /* Gather exchange return request products */
            let exchangeReturnProductList: List<ISalesReturnUpload> = [];
            forEach(getState().exchangeReturnSummary.data, (o) => {
                forEach(o.Reasons, (value) => {
                    const exchangeReturnRequestItem: ISalesReturnUpload = {
                        MfgDate: o.MfgDate,
                        PId: o.ProductId,
                        PName: o.ProductName,
                        PrincipalId: o.PrincipalId,
                        Qty: value.Qty,
                        Reason: value.ReasonName,
                        ReasonId: value.ReasonId,
                        UomId: o.UomId
                    };
                    exchangeReturnProductList.push(exchangeReturnRequestItem);
                });
            });

            /* Gather exchange order request products */
            let exchangeOrderProductList: List<IOrderUploadParams> = [];
            const products = getState().exchangeOrderSummary.data;;
            Object.keys(products).forEach(id => {
                /* Check of any piece or case count updated products */
                if (products[id].count > 0 || products[id].case_count > 0) {
                    const exchangeOrderRequestItem: IOrderUploadParams = {
                        PId: products[id].PId,
                        Qty: products[id].count + (products[id].case_count * products[id].conversionQty),
                        Price: products[id].price,
                        DiscountId: products[id].DiscountId,
                        SchemeId: products[id].SchemeId,
                        PrincipalId: products[id].PrincipalId,
                        ImageUrl: "",
                        DistributorId: products[id].DistributorId,
                        UomId: products[id].UomId,
                        UomCount: 1,
                        GroupId: products[id].SplitId,
                        GroupName: products[id].SplitName
                    };
                    exchangeOrderProductList.push(exchangeOrderRequestItem);
                }
            });

            /* Manage delivery date */
            let deliveryDate = "";
            /* Get cart reducer to get the express delivery date logic */
            const cartData = getState().cart;
            const exchangeSubmitData = getState().exchangeSubmit;

            if (cartData.expressDeliveryDate !== null && cartData.expressDeliveryDate !== "") {
                deliveryDate = moment(cartData.expressDeliveryDate, Constants.DD_MM_YYYY).format(Constants.YYYY_MM_DD);
            }
            else if (exchangeSubmitData.standardDeliveryDate !== "") {
                deliveryDate = moment(exchangeSubmitData.standardDeliveryDate, Constants.DD_MM_YYYY).format(Constants.YYYY_MM_DD);
            }

            /* Final request object to make API call */
            const finalRequestArray: IExchangeSubmitParams = {
                AddressId: getState().exchangeSubmit.selectedAddressId,
                DeliveryDate: deliveryDate,
                ExOrder: exchangeOrderProductList,
                ExReturn: exchangeReturnProductList
            }

            const response = await exchangeSubmitApi(finalRequestArray);

            dispatch({ type: types.EXCHANGE_SUBMIT_SUCCESS });

            /* Display the success toast message */
            dispatch(showMsgFromJson("common.alerts.success.orderSubmit", Constants.SUCCESS));

            /* Clear history filter when successful exchange order  */
            await dispatch(clearHistoryFilter());
            
            /* Load the order list and count after successful exchange submit */
            dispatch(getOrderHistory());

            /* Navigate the user to the orderHistory page after the successful transaction */
            const responseData = response.data.Data;
            dispatch(push(`${appRoutesConst.exchangeReturnResult}/${responseData.OrderId}/${responseData.OrderNo}/${responseData.ReturnId}/${responseData.ReturnNo}`));
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.EXCHANGE_SUBMIT_FAILURE, true));
        }
    };
};

/* Get delivery date for exchange return module */
export const getStandardDeliveryDate = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.DELIVERY_DATE_REQUEST_AND_RESPONSE, payload: { standardDeliveryDateLoading: true } });
        try {
            const response = await getDeliveryDateApi();

            dispatch({
                type: types.DELIVERY_DATE_REQUEST_AND_RESPONSE,
                payload: {
                    standardDeliveryDateLoading: false,
                    standardDeliveryDate: response.data.Data.DeliveryDate
                }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.DELIVERY_DATE_REQUEST_AND_RESPONSE, true));
        }
    };
};

export const updateSelectedAddressId = (addressId) => {
    return async (dispatch) => {
        dispatch({
            type: types.UPDATE_SELECTED_ADDRESS_ID,
            payload: { selectedAddressId: addressId }
        });
    };
};

/* Generic code for promise catch block */
export const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "") {
            dispatch({
                type: type,
                payload: { error: message }
            });
        }

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};